import { render, staticRenderFns } from "./ip.vue?vue&type=template&id=034da1ba&scoped=true&"
import script from "./ip.vue?vue&type=script&lang=js&"
export * from "./ip.vue?vue&type=script&lang=js&"
import style0 from "./ip.vue?vue&type=style&index=0&id=034da1ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034da1ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('034da1ba')) {
      api.createRecord('034da1ba', component.options)
    } else {
      api.reload('034da1ba', component.options)
    }
    module.hot.accept("./ip.vue?vue&type=template&id=034da1ba&scoped=true&", function () {
      api.rerender('034da1ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/safe/ip.vue"
export default component.exports